import { UserRoles } from './constants';

export type DocumentPermissionRoleOption = {
  label: string;
  value: UserRoles;
};

export const DOCUMENT_PERMISSION_ROLE_OPTIONS: DocumentPermissionRoleOption[] =
  [
    { label: 'Customer Support', value: UserRoles.CUSTOMER_CARE },
    // { label: 'Engineering', value: UserRoles.ENGINEERING },
    { label: 'Facility Admin', value: UserRoles.FACILITY_ADMIN },
    // { label: 'Scheduler', value: UserRoles.FACILITY_SCHEDULER },
  ];
